import { DisplayFlexS } from './DispalyFlexS';

export { DisplayFlexS };